/**
 * Mastermind — renders a mastermind game board with attempts and feedback.
 *
 * data: {
 *   attempts: [
 *     { guess: ["1", "2", "3"], black: 1, white: 1 },
 *     { guess: ["4", "5", "6"], black: 1, white: 0 },
 *     { guess: ["1", "5", "3"], black: 2, white: 0 },
 *   ]
 * }
 *
 * black = well placed (●), white = misplaced (○)
 * Guess items can be numbers, emoji, symbols, etc.
 */

const COLOR_MAP = {
    '🔴': '#dc2626', '🔵': '#2563eb', '🟡': '#eab308',
    '🟢': '#16a34a', '🟠': '#f97316', '🟣': '#9333ea',
    '⚫': '#1e293b', '⚪': '#e2e8f0',
};

function GuessSlot({ value }) {
    const color = COLOR_MAP[value];
    if (color) {
        return (
            <div className="qv-mm__slot qv-mm__slot--color" style={{ background: color }}>
                <span>{value}</span>
            </div>
        );
    }
    return (
        <div className="qv-mm__slot">
            <span>{value}</span>
        </div>
    );
}

function FeedbackPegs({ black = 0, white = 0, total }) {
    const pegs = [];
    for (let i = 0; i < black; i++) pegs.push('black');
    for (let i = 0; i < white; i++) pegs.push('white');
    while (pegs.length < total) pegs.push('empty');
    return (
        <div className="qv-mm__pegs">
            {pegs.map((type, i) => (
                <div key={i} className={`qv-mm__peg qv-mm__peg--${type}`} />
            ))}
        </div>
    );
}

export default function Mastermind({ data }) {
    const attempts = data?.attempts;
    if (!Array.isArray(attempts) || attempts.length === 0) return null;

    const slots = attempts[0]?.guess?.length || 3;

    return (
        <div className="qv-mm">
            <div className="qv-mm__header">
                <div className="qv-mm__header-label">Essai</div>
                <div className="qv-mm__header-label">Combinaison</div>
                <div className="qv-mm__header-label">Résultat</div>
            </div>
            {attempts.map((attempt, i) => (
                <div key={i} className="qv-mm__row">
                    <div className="qv-mm__num">{i + 1}</div>
                    <div className="qv-mm__guess">
                        {(attempt.guess || []).map((val, j) => (
                            <GuessSlot key={j} value={val} />
                        ))}
                    </div>
                    <FeedbackPegs black={attempt.black || 0} white={attempt.white || 0} total={slots} />
                </div>
            ))}
            <div className="qv-mm__legend">
                <span><span className="qv-mm__peg qv-mm__peg--black" /> Bien placé</span>
                <span><span className="qv-mm__peg qv-mm__peg--white" /> Mal placé</span>
            </div>
        </div>
    );
}
